import { Schema, object, string, number, array, bool, mixed } from "yup";
import {
  AssetDto,
  UserArticleForm,
  UserArticleAuthorType,
} from "../../lib-api";

export const assetValidationSchema: Schema<AssetDto> = object({
  id: string().required(),
  caption: string().label("Beskrivelse").required(),
  height: number(),
  width: number(),
  owner: string(),
  token: string().required(),
  url: string().required(),
});

export const validationSchema: Schema<UserArticleForm> = object().shape({
  assets: array().required().of(assetValidationSchema).label("Billede").min(1).max(4),
  rightsToAssets: bool()
    .required()
    .label("Brugsret til billederne")
    .oneOf([true], "Du skal bekræfte du har brugsret til billederne"),
  body: string().label("Indhold").required(),
  headline: string().required().label("Overskrift"),
  email: string().label("Email").email().required(),
  name: string().label("Navn").required(),
  type: mixed<UserArticleAuthorType>()
    .required()
    .oneOf([
      UserArticleAuthorType.PrivatePerson,
      UserArticleAuthorType.Company,
      UserArticleAuthorType.Association,
    ])
  ,
  companyName: string().label("Firmanavn").when("type", {
    is: UserArticleAuthorType.Company,
    then: (e) => e.required()
  }),
  associationName: string().label("Foreningsnavn").when("type", {
    is: UserArticleAuthorType.Association,
    then: (e) => e.required(),
  }),
  cvr: number()
    .integer()
    .label("CVR")
    .when("type", {
      is: UserArticleAuthorType.Company,
      then: (e) => e
        .transform((value, originalValue) =>
          /\s/.test(originalValue) ? NaN : value
        )
        .test("CVR check", "Ugyldigt CVR", (value) =>
          /\d{8}|A\/S\d{3,6}/.test(`${value}`)
        )
        .required(),
    }),
  facebookPageUrl: string().label("Facebook side"),
  recaptcha: string().required().label("Bevis du ikke er en robot"),
});
